import { fromJS } from 'immutable'
import {
  DIVISION_EDIT_REQUEST,
  DIVISION_EDIT_SUCCESS,
  DIVISION_EDIT_FAILURE,
  DIVISION_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DIVISION_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case DIVISION_EDIT_SUCCESS:
      return state
        .set('divisionEdit', fromJS(action.payload.updatedDivision))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case DIVISION_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('divisionEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case DIVISION_EDIT_RESET:
      return state
        .delete('divisionEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/division/division-edit-reducer.js